<div class="smart-app-banner" role="region" [attr.aria-label]="'App install banner'">
  <div class="banner-content" [class.isAndroid]="!isAppleDevice" *transloco="let t;">

    <button class="close-button" (click)="dismissBanner()" type="button" [attr.aria-label]="t('component.header.close')">
      &#10005;
    </button>

    <img class="app-icon" [class.smaller-logo]="appExists" [alt]="t('component.header.mobile_banner_logo')" [src]="appInfo.icon" (error)="handleImageError($event)">

    <div class="app-info" [class.isAndroid]="!isAppleDevice">
      <div class="app-name" [class.semi-bold]="appExists" [class.isAndroid]="!isAppleDevice">{{ appInfo.name }}</div>
      
      @if (!appExists) { <div class="app-subtitle" [class.isAndroid]="!isAppleDevice" >{{ appInfo.subtitle }}</div> }
      
      <div class="app-subtitle-2" [class.isAndroid]="!isAppleDevice">
        @if (!appExists && !isAppleDevice) {{{t('component.header.get_app_android')}}}
        @else if (!appExists && isAppleDevice) {{{t('component.header.get_app_ios')}}}
        @else {{{ t('component.header.open_app') }}}
      </div>
    </div>

    <button type="button" [class.action-button]="!appExists" [class.button-accent]="appExists" [class.isAndroid]="!isAppleDevice" (click)="onBannerClick()" [attr.aria-label]="getButtonText()">
      {{getButtonText()}} 
    </button>
  </div>
</div>